import {DeliveryTimeTypes} from './types'

export const DeliveryTimeTypeOptions = {
  now: {label: 'Entregar ahora', value: DeliveryTimeTypes.DELIVER_NOW},
  schedule: {label: 'Programar pedido', value: DeliveryTimeTypes.SCHEDULE_ORDER}
}

export const DELIVER_NOW_TIME = 'now'
